/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { mergeReducers } from 'ui-permit/shared-components/utils/async';
import { SHARED_PREFIX } from 'ui-permit/shared-components/constants';
import { getReservationSummaryImageUrlReducer } from 'ui-permit/shared-components/reducers';

const INITIAL_STATE = {
    reservationSummaryImageUrl: '',
};

const shared = mergeReducers(
    INITIAL_STATE,
    SHARED_PREFIX,
    getReservationSummaryImageUrlReducer
);

export const selectors = {
    getImageUrlSelector: (state) =>
        state.huntingpermit?.shared?.reservationSummaryImageUrl ?? '',
};

export default shared;
